export default __webpack_public_path__ + "static/media/person_3.928dd85c.png";